module.exports = __webpack_public_path__ + "components/rewards/absolutely-snow/static/logo-6c1ba45e4484bfdb1e3b4deb27fe9a1d.webp";